import {
    Edit,
    SimpleForm,
    TextInput,
    SelectArrayInput,
    BooleanInput,
    Toolbar,
    SaveButton,
    useRecordContext,
} from 'react-admin';
import { Typography, Box, Alert } from '@mui/material';

const roleChoices = [
    { id: 'TechSupport', name: 'Tech Support' },
    { id: 'Admin', name: 'Administrator' },
    { id: 'User', name: 'User' },
];

const UserTitle = () => {
    const record = useRecordContext();
    return <span>Edit User: {record?.email}</span>;
};

const EditToolbar = () => (
    <Toolbar>
        <SaveButton />
    </Toolbar>
);

export const UserEdit = () => (
    <Edit title={<UserTitle />}>
        <SimpleForm toolbar={<EditToolbar />}>
            <Box mb={2}>
                <Alert severity="info">
                    Email and username cannot be changed. Contact database admin for those changes.
                </Alert>
            </Box>

            <TextInput source="email" disabled fullWidth />
            <TextInput source="userName" label="Username" disabled fullWidth />

            <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>
                Account Status
            </Typography>

            <BooleanInput
                source="isLocked"
                label="Account Locked"
                helperText="Locked accounts cannot log in"
            />
            <BooleanInput
                source="emailConfirmed"
                label="Email Confirmed"
                helperText="Unconfirmed accounts have limited access"
            />

            <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>
                Roles
            </Typography>

            <SelectArrayInput
                source="roles"
                choices={roleChoices}
                fullWidth
                helperText="Select one or more roles for this user"
            />
        </SimpleForm>
    </Edit>
);
